module.exports = __webpack_public_path__ + "img/business-valuation.43a5fe1b.svg";